interface RuntimeConfig {
  BACKEND_URL?: string;
  APPINSIGHTS_CONNECTION_STRING?: string;
}

declare global {
  interface Window {
    env?: RuntimeConfig;
  }
}

export {};

// By design, Vite only exposes environment variables if they start with the prefix VITE_.
// IMPORTANT: Do not hard code URLs
const DEFAULT_CONFIG: RuntimeConfig = {
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  APPINSIGHTS_CONNECTION_STRING: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
};

async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const response = await fetch("/config.json", { cache: "no-store" });

    if (!response.ok) {
      throw new Error(`Config unavailable: HTTP ${response.status}`);
    }

    const config = (await response.json()) as Partial<RuntimeConfig>;

    return {
      BACKEND_URL: config.BACKEND_URL || DEFAULT_CONFIG.BACKEND_URL || window.location.origin,
      APPINSIGHTS_CONNECTION_STRING:
        config.APPINSIGHTS_CONNECTION_STRING || DEFAULT_CONFIG.APPINSIGHTS_CONNECTION_STRING || "",
    };
  } catch (error) {
    throw new Error(
      `Config unavailable: ${error instanceof Error ? error.message : String(error)}`
    );
  }
}

(async () => {
  const runtimeConfig = await loadRuntimeConfig();

  if (typeof window !== "undefined") {
    window.env = runtimeConfig;
  }

  const { bootstrapApp } = await import("./bootstrap");

  bootstrapApp();
})().catch((error) => {
  console.error("Failed to bootstrap Spaces app:", error);
});
